import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { eventPlatformApi, type DomainEvent } from '../../api/eventplatform';

export function LiveEventStreamPage() {
  const [events, setEvents] = useState<DomainEvent[]>([]);
  const [error, setError] = useState('');

  function load() {
    void eventPlatformApi.stream(100).then((r) => setEvents(r.events)).catch((e) => setError(String(e)));
  }

  useEffect(() => {
    load();
    const id = setInterval(load, 5000);
    return () => clearInterval(id);
  }, []);

  return (
    <div className="mx-auto max-w-6xl p-6">
      <Link to="/events" className="text-sm text-blue-600 hover:underline">← Event Hub</Link>
      <h1 className="mt-2 text-2xl font-semibold">Live Event Stream</h1>
      {error && <p className="mt-4 text-sm text-red-600">{error}</p>}
      <ul className="mt-6 space-y-2 font-mono text-sm">
        {events.map((e) => (
          <li key={e.id} className="rounded border px-3 py-2 dark:border-slate-700">
            <span className="text-blue-600">{e.name}</span> · {e.kind} · {e.timestamp}
          </li>
        ))}
      </ul>
    </div>
  );
}
